import {Modal} from "antd";
import WorkOrderManageForm from "../../../screens/web-v2/screens/work-orders/screens/manage/WorkOrderManageForm";
import {useRef, useState} from "react";
import type { DraggableData, DraggableEvent } from 'react-draggable';
import Draggable from 'react-draggable';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  ticketId?: string | undefined;
  assetOption?: SelectOption | undefined;
}

export default function WorkOrderManageModal(props: ModalProps) {
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
  const [disabled, setDisabled] = useState(true);
  const draggableRef = useRef<HTMLDivElement>(null);

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggableRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <Modal
      title={
        <div
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => {
            if (disabled) {
              setDisabled(false);
            }
          }}
          onMouseOut={() => {
            setDisabled(true);
          }}
          onFocus={() => {}}
          onBlur={() => {}}
        >
          Create Work Order
        </div>
      }
      centered
      styles={{
        content: {
          maxHeight: '80dvh',
          overflow: 'auto'
        }
      }}
      destroyOnClose
      open={props.open}
      onCancel={props.onClose}
      footer={(_, { CancelBtn }) => (
        <>
          <CancelBtn />
        </>
      )}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          nodeRef={draggableRef}
          onStart={(event, uiData) => onStart(event, uiData)}
        >
          <div ref={draggableRef}>{modal}</div>
        </Draggable>
      )}
    >
      <WorkOrderManageForm
        onSuccess={props.onSuccess}
        ticketId={props.ticketId}
        assetOption={props.assetOption}
      />
    </Modal>
  );
}
